module.exports = __webpack_public_path__ + "img/pro-zdslider3.4c21586c.png";